export const environment = {
    production: false,
    apiEndpoint: 'https://uat-api.eduscript.ai/api/',
    orgName: 'demo',
};
